import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "-4 -3 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.04006 1.31491L7.49067 0.66914C5.22633 -0.313011 2.55121 -0.24471 0.338989 1.07847C0.11504 1.21242 -0.00581983 1.45494 0.00321021 1.7003C0.00108659 1.72248 0 1.74497 0 1.76771V18.3078C0 18.6901 0.30695 19 0.685592 19C1.06423 19 1.37118 18.6901 1.37118 18.3078V13.0961C3.11351 12.1996 5.21888 12.1951 7.02058 12.9856L8.4773 13.6671L8.49161 13.6736C10.7836 14.6823 13.4519 14.5971 15.6639 13.2741C15.8722 13.1495 16 12.9231 16 12.6786V1.63991C16 1.39123 15.8679 1.16166 15.6539 1.03854C15.4399 0.915408 15.1769 0.917646 14.965 1.0444C13.1633 2.12203 10.9751 2.16634 9.0524 1.3202L9.04006 1.31491Z" }, null, -1)
  ])))
}
export default { render: render }